import { css } from '@emotion/css';

export const taskGroupByFilterStyles = css`
  .MuiDivider-root {
    opacity: 0;
  }
`;
